














import {defineComponent, onMounted} from "@vue/composition-api";
import HttpService from '@/shared/services/http-service';
import EventService from '../services/events-service';
import {useActions, useGetters} from "vuex-composition-helpers";
export default defineComponent({
  name: 'Dates',
  setup: () => {
    let dateNames: string[] = []
    const {setActiveDate, setEvents, nextWeek, prevWeek, setLoading, clearErrors, setErrors}: {
      setActiveDate: Function,
      setEvents: Function,
      nextWeek: Function,
      prevWeek: Function,
      setLoading: Function,
      clearErrors: Function,
      setErrors: Function
    } = useActions(["setActiveDate", "setEvents", "nextWeek", "prevWeek", "setLoading", "clearErrors", "setErrors"]);
    const {
      dates,
      config,
      activeDate,
      language,
      currentDate
    } = useGetters(["dates", "config", "activeDate", "language", "currentDate"]);

    function handleNextWeek(): void {
      nextWeek().then(() => {
        setActiveDate(dates.value[0]);
        getEvents()
      }).catch((error: string) => {
        console.error(error);
      })
    }

    function handlePrevWeek(): void {
      prevWeek().then(() => {
        setActiveDate(dates.value[0]);
        getEvents()
      }).catch((error: string) => {
        console.error(error);
      })
    }

    function setDateNames(): void {
      dateNames = config.value.language.toLowerCase() === 'nl' ? ['Ma', 'Di', 'Wo', 'Do', 'Vr'] : ['Mon', 'Tue', 'Wed', 'Thu', 'Fri']
    }

    onMounted(() => {
      setDateNames();
    })

    function getDateName(day: number): string {
      return dateNames[day];
    }

    function handleActiveDate(date: Date): void {
      setActiveDate(date);
      getEvents();
    }

    function getEvents() {
      setLoading(true);
      clearErrors();

      EventService.getSchedule(config.value, activeDate.value, HttpService)
          .then(events => {
            setEvents(events);
          })
          .catch(error => {
           setErrors([
              config.value.language.toLowerCase() === 'nl'
                  ? 'Er gaat iets fout, probeer het later nog een keer. ' + error
                  : 'Something went wrong, please try again later. ' + error
            ]);
          })
          .finally(() =>
              setLoading(false)
          );
    }

    return {
      handleNextWeek,
      handlePrevWeek,
      getDateName,
      handleActiveDate,
      activeDate,
      dates,
      currentDate
    }
  }
})

